import type { ExperienceModule } from "@intelligems/ig-types/dtos/experience-modules";
import { useGetExperiencesList } from "@src/api/experiences-list/get-experiences-list";

const useModuleExperienceList = (
  module: ExperienceModule,
  modulesToCheck: ReadonlySet<ExperienceModule>
) => {
  const isChecked = modulesToCheck.has(module);
  const list = useGetExperiencesList({
    module,
    enabled: isChecked,
    fetchAllPages: isChecked,
  });
  const hasExperiences =
    isChecked &&
    (list.data?.experiencesList ?? []).some(
      (experience) => !experience.archivedAtTs
    );
  return {
    module,
    hasExperiences,
    isLoading:
      isChecked &&
      (list.isLoading || (!hasExperiences && list.isFetchingAllPages)),
  };
};

export const useModulesWithExperiences = (
  modulesToCheck: ReadonlySet<ExperienceModule>
): { modules: ReadonlySet<ExperienceModule>; isLoading: boolean } => {
  const lists = [
    useModuleExperienceList("content", modulesToCheck),
    useModuleExperienceList("checkout", modulesToCheck),
    useModuleExperienceList("postPurchase", modulesToCheck),
    useModuleExperienceList("pricing", modulesToCheck),
    useModuleExperienceList("merchandising", modulesToCheck),
    useModuleExperienceList("shipping", modulesToCheck),
  ];

  return {
    modules: new Set(
      lists.filter((list) => list.hasExperiences).map((list) => list.module)
    ),
    isLoading: lists.some((list) => list.isLoading),
  };
};
